import { Radio, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { SCHEDULE_FREQUENCY } from 'api/types/card-schedule.types';
import { useCompanyFeatureFlags } from 'hooks/use-company-feature-flags';

import type { ScheduleFrequency } from 'api/types/card-schedule.types';
import type { ReactNode } from 'react';

type ScheduleStepProps = {
  frequency: ScheduleFrequency;
  onFrequencyChange: (frequency: ScheduleFrequency) => void;
};

export default function ScheduleStep({
  frequency,
  onFrequencyChange,
}: ScheduleStepProps): ReactNode {
  const { t } = useTranslation(['Card']);
  const { isDailyCardScheduleEnabled } = useCompanyFeatureFlags(
    'isDailyCardScheduleEnabled',
  );

  return (
    <Radio.Group
      value={frequency}
      onChange={(val) => onFrequencyChange(val as ScheduleFrequency)}
    >
      <Stack gap="md">
        {Object.entries(SCHEDULE_FREQUENCY)
          .filter(
            ([, value]) =>
              value !== SCHEDULE_FREQUENCY.DAILY ||
              isDailyCardScheduleEnabled ||
              frequency === SCHEDULE_FREQUENCY.DAILY,
          )
          .map(([key, value]) => (
            <Radio
              key={key}
              value={value}
              label={t(`Card:schedule.frequency.${value}`)}
              disabled={
                value === SCHEDULE_FREQUENCY.DAILY &&
                !isDailyCardScheduleEnabled
              }
            />
          ))}
      </Stack>
    </Radio.Group>
  );
}
